import dayjs from "dayjs";
// @ts-expect-error - dayjs plugin types may not be available in all environments
import updateLocale from "dayjs/plugin/updateLocale";

/**
 * Global dayjs locale setup shared by every Ant Design DatePicker / RangePicker.
 *
 * antd's date panels read the first weekday and the week-number column from the
 * dayjs "en" locale (rc-picker maps antd's `en_US` to dayjs `en`). We make it
 * ISO 8601 / Swedish:
 * - `weekStart: 1`  -> weeks start on Monday
 * - `yearStart: 4`  -> week 1 is the week containing January 4
 *   (e.g. 2026-10-08 is week 41, 2027-01-01 is week 53 of 2026)
 *
 * Imported for its side effect from App.tsx so it runs before any picker renders.
 */
dayjs.extend(updateLocale);
// @ts-expect-error - updateLocale may not have types
dayjs.updateLocale("en", {
  weekStart: 1, // Monday
  yearStart: 4, // ISO 8601: week 1 contains Jan 4
});
